var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKycIcon = function SvgKycIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#434B5F",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 22,
    height: 18,
    rx: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#434B5F",
    strokeWidth: 2,
    d: "M4.941 13.571h10.588M4.941 7.143H12"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#434B5F",
    cx: 17.647,
    cy: 7.143,
    rx: 2.118,
    ry: 2.143
  }))));
};
export default SvgKycIcon;